module.exports = __webpack_public_path__ + "img/dialog_bg_2.c41687ec.png";